import React, { useState, useEffect, useRef } from 'react';

export const CATEGORIES = [
  { value: 'faescht',  label: 'Fäscht',   icon: '🎉' },
  { value: 'fasnacht', label: 'Fasnacht', icon: '🎭' },
  { value: 'sport',    label: 'Sport',    icon: '🏃' },
  { value: 'bar',      label: 'Bar',      icon: '🍺' },
  { value: 'club',     label: 'Club',     icon: '🎵' },
  { value: 'konzert',  label: 'Konzert',  icon: '🎤' },
  { value: 'kultur',   label: 'Kultur',   icon: '🎨' },
  { value: 'sonstige', label: 'Sonstige', icon: '📌' },
];

const CategoryDropdown = ({ value, onChange, allowEmpty = true, className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = CATEGORIES.find(c => c.value === value) || null;

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleSelect = (cat) => {
    onChange(cat ? cat.value : '');
    setOpen(false);
  };

  return (
    <div className={`canton-dropdown ${className}`} ref={ref}>
      <button
        type="button"
        className="canton-dropdown-toggle"
        onClick={() => setOpen(o => !o)}
      >
        {selected ? (
          <>
            <span className="category-icon">{selected.icon}</span>
            <span>{selected.label}</span>
          </>
        ) : (
          <span className="canton-placeholder">Alle Kategorien</span>
        )}
        <span className="canton-arrow">▼</span>
      </button>

      {open && (
        <ul className="canton-dropdown-list">
          {allowEmpty && (
            <li
              className={`canton-option ${!value ? 'selected' : ''}`}
              onMouseDown={() => handleSelect(null)}
            >
              <span className="canton-placeholder">Alle Kategorien</span>
            </li>
          )}
          {CATEGORIES.map(cat => (
            <li
              key={cat.value}
              className={`canton-option ${value === cat.value ? 'selected' : ''}`}
              onMouseDown={() => handleSelect(cat)}
            >
              <span className="category-icon">{cat.icon}</span>
              <span>{cat.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryDropdown;
